var _circle, _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLlmEmptyState = function SvgLlmEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 52,
    fill: "none",
    viewBox: "0 0 62 52"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.133,
    cy: 25.133,
    r: 25.133,
    fill: "#E5E5FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeDasharray: "2.25 2.25",
    d: "M18 20v-1.72a2 2 0 0 1 2-2h11a2 2 0 0 0 2-2V12M48 20v-1.72a2 2 0 0 0-2-2H35a2 2 0 0 1-2-2V12M47 32v1.72a2 2 0 0 1-2 2H35a2 2 0 0 0-2 2V40M19 32v1.72a2 2 0 0 0 2 2h10a2 2 0 0 1 2 2V40"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 13,
    x: 14.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M18 5h30M18 9h22"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 13,
    x: 14.5,
    y: 38.5,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M18 43h30M18 47h22"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 13,
    x: 36.5,
    y: 19.5,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M41 24h17.333M41 28h13"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 13,
    x: 3.5,
    y: 19.5,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M7 24h17.333M7 28h13"
  })));
};
export default SvgLlmEmptyState;